import {useEffect, useState} from "react";
import useSWRInfinite, {SWRInfiniteConfiguration} from "swr/infinite";
import {objToQueryString} from "../lib/fns";
import {fetcher} from "api/fetcher";
import {TokenStorage} from "api/token";
import {GetListResponse} from "shared/types";

type ParamType = string | Record<string, unknown>;
type Props = {
  url: string | null,
  params?: ParamType,
  pageSize?: number,
  options?: SWRInfiniteConfiguration
}
export const useDataAll = <T>({url, params, pageSize = 300, options}: Props) => {
  const [listData, setListData] = useState<T[]>([]);
  
  const getKey = (pageIndex: number, previousPageData: GetListResponse<T>) => {
    if (!url || !TokenStorage.getToken()) {
      return null;
    }
    
    if (pageIndex === 0) {
      let paramString = "";
      
      if (typeof params == "string") paramString = params; else paramString = objToQueryString(params, true);
      return (url + `?page_size=${pageSize}&${paramString}`);
    }
    if (previousPageData && previousPageData.next) return previousPageData.next;
    return null; // reached the end
  };
  
  const {data, error, setSize, isValidating, isLoading, mutate} = useSWRInfinite<GetListResponse<T>>(getKey, fetcher, options
    ? options
    : {
      initialSize: 1, revalidateOnFocus: false, revalidateIfStale: false, revalidateFirstPage: false,
    });
  
  useEffect(() => {
    if (data && data?.length > 0) {
      const lastRes = data[data?.length - 1];
      if (lastRes && lastRes.current_page * lastRes.items_per_page < lastRes.count) {
        setSize((size) => size + 1);
      }
      else {
        let listData: T[] = [];
        data.forEach((item) => {
          if (item?.results) {
            listData = listData.concat(item.results);
          }
        });
        setListData(listData);
      }
    }
  }, [data, setSize, url]);
  
  return {
    listData, error, isLoading, isValidating, mutate
  };
};
